<template>
  <div>
    <div class="row align-items-center">
      <LmCheckbox
        class="col-12 font-weight-bold"
        variant="switch"
        :labelSingle="$t('visibility_depend_on_condition')"
        v-model="visibilityDependOnConditionsData.isActive"
        @input="changevisibilityDependOnCondition($event)"
      />
    </div>
    <p v-if="visibilityDependOnConditionsData.conditions.length && visibilityDependOnConditionsData.isActive" class="m-0 mt-2 col-12 pl-0">{{$t('show_field_if')}}</p>
    <template v-if="visibilityDependOnConditionsData.isActive">
      <div class="row align-items-center" v-for="(condition, index) in visibilityDependOnConditionsData.conditions" :key="index">
        <LmSelect
          class="col-3"
          :id="`${id}select-left-value-to-compare-select`"
          :options="leftValueToCompareOptions"
          v-model="condition.leftValueToCompare"
          @input="$emit('changeVisibilityDependOnConditions', visibilityDependOnConditionsData)"
        />
        <p class="m-0 col-1">{{$t('Is')}}</p>
        <LmSelect
          class="col-3"
          :id="`${id}select-compare`"
          :options="toCompareOptions"
          v-model="condition.comparation"
          @input="$emit('changeVisibilityDependOnConditions', visibilityDependOnConditionsData)"
        />
        <p class="m-0 col-1">{{$t('To')}}</p>
        <LmTextInput
          :id="`${id}right-value-to-compare`"
          class="col-3 mt-4"
          v-model="condition.rightValueToCompare"
          @input="$emit('changeVisibilityDependOnConditions', visibilityDependOnConditionsData)"
          />
        <font-awesome-icon v-if="visibilityDependOnConditionsData.conditions.length > 1" class="clickable col-1 mt-2" icon="trash" @click="removeCondition(index)" />
      </div>
    </template>
    <LmButton
      v-if="visibilityDependOnConditionsData.conditions.length && visibilityDependOnConditionsData.isActive"
      type="submit"
      buttonClass="btn-primary mt-4"
      :id="`${id}add-conditional`"
      :value="$t('add_conditional')"
      @click.native="addCondition"
    />
  </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
export default {
  data () {
    return {
      visibilityDependOnConditionsData: {
        isActive: false,
        conditions: []
      },
      toCompareOptions: {
        disabledOption: this.$t('Element'),
        content: [
          { value: '===', text: this.$t('equal') },
          { value: '!==', text: this.$t('different') },
          { value: '>', text: this.$t('higher') },
          { value: '>=', text: this.$t('greater_than_or_equal') },
          { value: '<', text: this.$t('less') },
          { value: '<=', text: this.$t('less_than_or_equal') }
        ]
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmButton,
    LmCheckbox

  },
  methods: {
    removeCondition (conditionIndex) {
      this.visibilityDependOnConditionsData.conditions.splice(conditionIndex, 1)
    },
    addCondition () {
      this.visibilityDependOnConditionsData.conditions.push({
        leftValueToCompare: '',
        comparation: '',
        rightValueToCompare: ''
      })
    },
    changevisibilityDependOnCondition (active) {
      if (!this.visibilityDependOnConditionsData.conditions.length) {
        this.addCondition()
      }
      this.$emit('changeVisibilityDependOnConditions', this.visibilityDependOnConditionsData)
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    }
  },
  watch: {
    visibilityDependOnConditions () {
      this.visibilityDependOnConditionsData = this.visibilityDependOnConditions
    }
  },
  created () {
    this.visibilityDependOnConditionsData = this.visibilityDependOnConditions
  }
}
</script>
